// extracted by mini-css-extract-plugin
export var businessAddressContainer = "business-address-module--businessAddressContainer--Gw-XU";
export var businessAddressLink = "business-address-module--businessAddressLink--CeJeP";
export var businessAddress = "business-address-module--businessAddress--ykz-S";